module.exports = __webpack_public_path__ + "3e693737561a18d8f06f684a19cef1d7.jpg";